$(function () {
	// initialize nette ajax plugin
	$.nette.init();

	// initialize confirmation dialogs
	window.brko.confirmation.init("#confirmation-dialog");

	window.brko.selectize.init("select.selectize");
});
